declare var pConf: any;
export async function checkStock(siteId: number) {
    try {
        const url = "https://www.workup-system.com/StockCheck/Index?productCode=" + pConf.productId + "&siteInfoID=" + siteId;
        const html = await jQuery.ajax({
            type: "GET",
            url: url,
            dataType: "html"
        });
        jQuery('.stockInfo').remove();
        jQuery('.detail_cart_box').after(html);

    }
    catch (e) {
        console.log(e);
    }
}

export async function checkStockSp(siteId: number) {
    try {
        const url = "https://www.workup-system.com/StockCheck/SP?productCode=" + pConf.productId + "&siteInfoID=" + siteId;
        const html = await jQuery.ajax({
            type: "GET",
            url: url,
            dataType: "html"
        });
        jQuery('.stockInfo').remove();
        jQuery('.quantity').after(html);
    }
    catch (e) {
        console.log(e);
    }
}

export async function checkStockRSP(siteId: number) {
    try {
        const url = "https://www.workup-system.com/StockCheck/Index?productCode=" + pConf.productId + "&siteInfoID=" + siteId;
        const html = await jQuery.ajax({
            type: "GET",
            url: url,
            dataType: "html"
        });
        jQuery('.stockInfo').remove();
        jQuery('.detail_section.box_both_ends_space.return').after(html);
    }
    catch (e) {
        console.log(e);
    }
}
export async function checkStockRSP2(siteId: number) {
    try {
        const url = "https://www.workup-system.com/StockCheck/Index?productCode=" + pConf.productId + "&siteInfoID=" + siteId;
        const html = await jQuery.ajax({
            type: "GET",
            url: url,
            dataType: "html"
        });
        jQuery('.stockInfo').remove();
        jQuery('.detail_section.box_both_ends_space.return').after(html);
    }
    catch (e) {
        console.log(e);
    }
}

export async function checkStockRSP3(siteId: number) {
    try {
        const url = "https://www.workup-system.com/StockCheck/Index?productCode=" + pConf.productId + "&siteInfoID=" + siteId;
        const html = await jQuery.ajax({
            type: "GET",
            url: url,
            dataType: "html"
        });
        jQuery('.stockInfo').remove();
        jQuery('.product_info_wrapper').after(html);
    }
    catch (e) {
        console.log(e);
    }
}